import React from 'react';
import pluralize from 'pluralize';
import { useDispatch, useSelector } from 'react-redux';

import { ERROR, QUOTING, START } from 'shared/data/quoteSteps';
import { selectAssemblyDataForPrices } from 'mx_pcb_assembly/store/selectors';
import { priceSelected } from 'mx_pcb_assembly/store/slice';

import AutomaticQuoteError from 'shared/components/AutomaticQuoteError';
import QuoteLoading from 'shared/components/price/QuoteLoading';
import PriceMatrix from 'shared/components/price/PriceMatrix';
import HowItWorks from 'shared/product_tabs/tab_assembly/components/HowItWorks';
import QuoteActionBar from 'mx_pcb_assembly/components/QuoteActionBar';

const Prices = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
  } = useSelector(selectAssemblyDataForPrices);

  if (quoteStep === ERROR) {
    return <AutomaticQuoteError />;
  }

  if (quoteStep === QUOTING) {
    return <QuoteLoading />;
  }

  const onPriceSelect = (data) => {
    dispatch(priceSelected({ ...data }));
  };

  const lineItem = quote.line_items.find((i) => i.product_key === 'assembly-mx');
  const { restricted_price } = lineItem;

  return (
    <div className="container-fluid quote-result">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-uppercase mb-0">Mexico PCB Assembly</h2>
        {quoteStep !== QUOTING && <QuoteActionBar />}
      </div>
      <div className="row">
        <div className="col-12">
          <PriceMatrix
            leadTimeText={(lt) => `${pluralize('week', lt)}`}
            tableStripe={quoteStep === START}
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep}
            restrictedPrice={restricted_price} />
        </div>
        <div>
          <ul>
            <li>First Article cost is included (Lead Time = 2 to 3 weeks).</li>
            <li>Production Lead Time starts after First Article is approved.</li>
            <li>To return the leftover parts and SMT Stencil, an additional customs fee (~$500.00) will be applied.</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <HowItWorks />
      </div>
    </div>
  );
};

export default Prices;
